'use client';

import { parseUserAgent } from '@diritto/common/utils/userAgent';
import { useInAppState } from 'contexts/InAppProvider';
import { EventsPage } from 'app/(appHeader)/events/EventsPage';
import { eventsDescription } from 'constants/metadata';

export default function Page() {
  const { userAgent } = useInAppState();
  const { isApp } = parseUserAgent(userAgent ?? '');

  return (
    <>
      <title>이벤트 목록 | 디리토</title>
      <meta name="description" content={eventsDescription} />
      <EventsPage isApp={isApp} />
    </>
  );
}
